import { put, take, fork, call, all, select } from "redux-saga/effects";
import { WarrntyItemAction, WarrntyItemScope } from "./types";
import {
  enableScopeLoading,
  disableScopeLoading,
} from "../scope-loading/actions";
import * as Api from "../../service/api";
import { ScopeErrorAction } from "../scope-error/types";
import { mapApiFlatData } from "./helpers";
import { RootState } from "../root-reducer";
import { showSuccesModal } from "./actions";
import toast from "react-hot-toast";

function* fetchHelperData() {
  while (true) {
    yield take(WarrntyItemAction.FETCH_OPTIONS);
    yield put(enableScopeLoading(WarrntyItemScope));

    try {
      const [damageItemTypes, colors, materialTypes, manufacturers] = yield all(
        [
          call(Api.claimOptions.damageItemTypes),
          call(Api.claimOptions.colors),
          call(Api.claimOptions.materialTypes),
          call(Api.claimOptions.manufacturers),
        ]
      );

      yield put({
        type: WarrntyItemAction.SET_OPTIONS,
        payload: {
          claimItemTypes: damageItemTypes?.map(mapApiFlatData),
          materialTypes: materialTypes?.map(mapApiFlatData),
          manufacturers: manufacturers?.map(mapApiFlatData),
          colors: colors?.map(mapApiFlatData),
        },
      });
    } catch (error) {
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: WarrntyItemScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(WarrntyItemScope));
    }
  }
}

function* addWarrntyItemFlow() {
  while (true) {
    const request = yield take(WarrntyItemAction.ADD);
    yield put(enableScopeLoading(WarrntyItemScope));
    try {
      const data = yield call(Api.warranty.insertWarrntyItem, request.payload);
      if (data?.message === "Succeed") {
        yield put(showSuccesModal());
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong", {
        position: "bottom-center",
      });
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: WarrntyItemScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(WarrntyItemScope));
    }
  }
}

export default function* warrntyItemSaga() {
  yield fork(fetchHelperData);
  yield fork(addWarrntyItemFlow);
}
